<template>
	<div class="forgot-password">

		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle">

			<!-- Forgot Password Form Column -->
			<a-col :span="24" :md="12" :lg="{span: 12, offset: 0}" :xl="{span: 6, offset: 2}" class="col-form">
				<h1 class="mb-15">Forgot Password</h1>
				<h5 class="font-regular text-muted">
					{{ submitted ? 'Check your email for reset instructions' : 'Enter your email to receive a password reset link' }}
				</h5>

				<!-- Success Message -->
				<a-alert
					v-if="submitted"
					type="success"
					:message="successMessage"
					description="If an account exists with that email, you will receive password reset instructions shortly."
					show-icon
					class="mb-20"
				/>

				<!-- Forgot Password Form -->
				<a-form
					v-if="!submitted"
					id="forgot-password-form"
					:form="form"
					class="forgot-password-form"
					@submit="handleSubmit"
					:hideRequiredMark="true"
				>
					<a-form-item class="mb-10" label="Email" :colon="false">
						<a-input
							v-decorator="[
								'email',
								{ rules: [
									{ required: true, message: 'Please input your email!' },
									{ type: 'email', message: 'Please enter a valid email address!' }
								] },
							]"
							placeholder="Email"
							type="email"
						/>
					</a-form-item>

					<a-form-item>
						<a-button
							type="primary"
							block
							html-type="submit"
							class="forgot-password-button"
							:loading="loading"
						>
							{{ loading ? 'SENDING...' : 'SEND RESET LINK' }}
						</a-button>
					</a-form-item>

					<div class="text-center">
						<span class="text-muted">Remember your password? </span>
						<router-link to="/sign-in" class="font-bold">Sign In</router-link>
					</div>
				</a-form>
				<!-- / Forgot Password Form -->

				<!-- Return to Sign In Button (after submission) -->
				<div v-if="submitted" class="text-center mt-20">
					<a-button type="primary" block @click="goToSignIn">
						RETURN TO SIGN IN
					</a-button>
				</div>
			</a-col>
			<!-- / Forgot Password Form Column -->

			<!-- Image Column -->
			<a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
				<img src="images/zerocents-logo.png" alt="">
			</a-col>
			<!-- / Image Column -->

		</a-row>

	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			submitted: false,
			successMessage: 'Reset link sent!'
		}
	},
	beforeCreate() {
		// Creates the form and adds to it component's "form" property.
		this.form = this.$form.createForm(this, { name: 'forgot_password' });
	},
	methods: {
		// Handles input validation after submission.
		async handleSubmit(e) {
			e.preventDefault();
			this.form.validateFields(async (err, values) => {
				if (!err) {
					this.loading = true;
					try {
						// Forgot password request
						const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8080';
						const response = await fetch(`${apiBaseUrl}/api/auth/forgot-password`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
							},
							body: JSON.stringify({
								email: values.email,
							}),
						});

						if (!response.ok) {
							throw new Error('Failed to send reset email');
						}

						const data = await response.json();

						// Show success message
						this.submitted = true;
						this.successMessage = data.message || 'Reset link sent!';

					} catch (error) {
						console.error('Error requesting password reset:', error);
						this.$notification.error({
							message: 'Error',
							description: 'Failed to send password reset email. Please try again.',
							duration: 5,
						});
					} finally {
						this.loading = false;
					}
				}
			});
		},
		goToSignIn() {
			this.$router.push('/sign-in');
		}
	},
}
</script>

<style lang="scss" scoped>
	body {
		background-color: #ffffff;
	}

	.forgot-password {
		min-height: 100vh;
		display: flex;
		align-items: center;
		background-color: #ffffff;
		padding: 0 20px;

		.text-center {
			text-align: center;
		}

		.font-bold {
			font-weight: 600;
			color: #1890ff;

			&:hover {
				color: #40a9ff;
			}
		}
	}

	.col-img {
		img {
			max-width: 100%;
			height: auto;
			display: block;
		}
	}
</style>
